const getters = {
    user: state => state.user,
    global: state => state.global,
    token: state => state.user ? state.user.loginToken : null
};
export default getters
